export default __webpack_public_path__ + "static/media/twitterbutton.cf54e512.svg";